






































































































import Vue from 'vue';
import util from '@/utils';
import { State } from 'vuex-class';
import { Component } from 'vue-property-decorator';
import { TTeacherInfo } from '@/types/views/school';
import { updateTeacher, getTeacherById, resetTeacherPwd } from '@/api/school';
import validate from '@/utils/validate';
export type TRules = {
  [key: string]: TVerification[];
};

export type TVerification = {
  required: boolean;
  message?: string;
  trigger: string;
  validator?: Function;
};
const namespace = 'user'
@Component({})
export default class Info extends Vue {
  @State('orgId', {namespace})orgId!: string
  private rules: TRules = {
    teacherName: [
      {
        required: true,
        message: '老师名称不能为空',
        trigger: 'blur'
      }
    ],
    layer: [
      {
        required: true,
        message: '老师等级不能为空',
        trigger: 'blur'
      }
    ],
    education: [
      {
        required: true,
        message: '教育程度不能为空',
        trigger: 'blur'
      }
    ],
    phone: [
      {
        required: true,
        validator: validate.validatorPhone_rule,
        trigger: 'blur'
      }
    ],
    age: [
      {
        required: true,
        validator: validate.validatorNumber_rule,
        trigger: 'blur'
      }
    ]
  };
  private teacherInfo: TTeacherInfo = {
    id: '',
    account: {},
    teacherName: '',
    status: '',
    layer: '',
    sex: '',
    age: '',
    phone: '',
    education: '',
    teacherDes: '',
    avatarImageURL: ''
  };
  get accountemail(): string {
    return this.teacherInfo.account.accountemail;
  }
  private activated() {
    this.teacherInfo.id = (this.$route as any).params.id;
    this.getTeacherInfo((this.$route as any).params.id);
  }
  private showDialog() {
    (this.$refs.dialog as any).visible = true;
  }
  handleConfirm(url: string) {
    this.teacherInfo.avatarImageURL = url;
  }
  /**
   * 更新老师信息
   * @param {string} formName 表单名字
   */
  private save(formName: string) {
    (this.$refs[formName] as any).validate(async (valid: boolean) => {
      if (!valid) return;
      try {
        this.teacherInfo.id = (this.$route as any).params.id;
        this.teacherInfo.orgId = this.orgId
        delete this.teacherInfo.account;
        const res: any = await updateTeacher({
          teacherDTOStr: JSON.stringify(this.teacherInfo)
        });
        if (res.code === '000001') {
          this.$message.success('更新成功');
          this.getTeacherInfo(this.$route.params.id);
        }
      } catch (e) {
        this.$message.error(e);
      }
    });
  }

  /**
   * 获取老师信息
   * @param {string} id 老师Id
   */
  private async getTeacherInfo(id: string) {
    try {
      let res: any = await getTeacherById({ id });
      util.copy(this.teacherInfo, res);
    } catch (e) {
      this.$message.error(e);
    }
  }
  /**
   * 重置密码
   */
  private async resetPwd() {
    try {
      const data = await resetTeacherPwd({
        teacherId: parseInt(this.teacherInfo.id, 10)
      });
      if (data) {
        this.$message.success('密码重置成功');
      } else {
        this.$message.success('密码重置失败');
      }
    } catch (e) {
      this.$message.error(e);
    }
  }
  private disableTeacher() {
    this.teacherInfo.status = 'I';
    this.save('form');
  }
}
